import { useLayoutEffect, useRef, useState } from "react";
import capHeightFromBbox from "../util/capHeightFromBbox";

interface SvgWidthResizeTextProps {
  text: string;
  color: string;
  x: number;
  capTop: number;
  width: number;
  hasEffect: boolean;
  fontFamily?: string;
  maxFontSize?: number;
  onLayout: (capHeight: number, descent: number) => void;
}

export default function SvgWidthResizeText(
  props: SvgWidthResizeTextProps)
{
  const { text, color, x, capTop, width, onLayout, hasEffect, maxFontSize = 750, fontFamily = 'Montserrat' } = props;
  const fontWeight = 'bold';
  const headerTextRef = useRef<SVGTextElement>(null);
  const [baselineOffset, setBaselineOffset] = useState(0);
  const [headerFontSize, setHeaderFontSize] = useState(240);
  const [offsetX, setOffsetX] = useState(0);

  const headerY = capTop + baselineOffset;

  useLayoutEffect(() => {
    if (!headerTextRef || !headerTextRef.current) {
      return;
    }
    const bbox = headerTextRef.current.getBBox();
    const { capHeight, descent } = capHeightFromBbox(bbox, headerY);
    const factor = Math.min(width / bbox.width, maxFontSize / headerFontSize);
    setOffsetX((width - factor * bbox.width) / 2);
    setBaselineOffset(capHeight * factor);
    setHeaderFontSize(headerFontSize * factor);
    onLayout(capHeight * factor, descent * factor);
  }, [text, width])

  const textAnchor = "start";
  const blurId = `blurFilter${headerFontSize}`;
  const letterSpacing = headerFontSize * 0.05;

  return (
    <g>
      {hasEffect && <defs>
        <filter id={blurId} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation={headerFontSize * 0.1} />
        </filter>
      </defs>}
      {hasEffect && <text 
        style={{
          overflow: 'hidden'
        }}
        x={x + offsetX} y={headerY} 
        fontSize={headerFontSize} 
        stroke="#fff"
        strokeWidth={0.15 * headerFontSize * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        letterSpacing={letterSpacing}
        textAnchor={textAnchor}
        filter={`url(#${blurId})`}
      >
        {text}
      </text>}
      {hasEffect &&<text 
        x={x + offsetX} y={headerY} 
        fontSize={headerFontSize} 
        fill="none"
        stroke="#DAE5D4"
        strokeWidth={0.07 * headerFontSize}
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        letterSpacing={letterSpacing}
        textAnchor={textAnchor}
      >
        {text}
      </text>}
      <text ref={headerTextRef} 
        x={x + offsetX} y={headerY} 
        fontSize={headerFontSize} 
        fill={color}
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        letterSpacing={letterSpacing}
        textAnchor={textAnchor}
      >
         {text}
      </text>
    </g>
  )

}

